// Copyright 2026 NXGN Management, LLC. All Rights Reserved.
import { NextgenCustomer } from '@/services/customers'
import { normalizeName } from '@/utils/helpers'

export const EXISTING_CUSTOMER_TAG_LABEL = 'Existing'

export const UNSOURCED_CUSTOMER_MESSAGE =
  'No matches found. Customers must exist in LASI before they can be added here.'

type ExistingCustomerKeys = {
  existingGcns: Set<string>
  existingNormalizedNames: Set<string>
}

/**
 * A LASI customer is already in TCC when its GCN matches, since GCN is the only
 * reliable key. Customers without a GCN fall back to the normalized name.
 */
export const isExistingNextgenCustomer = (
  customer: NextgenCustomer,
  { existingGcns, existingNormalizedNames }: ExistingCustomerKeys
): boolean => {
  const gcn = String(customer.gcn ?? '').trim()

  if (gcn) return existingGcns.has(gcn.toLowerCase())

  const normalizedName = normalizeName(String(customer.name ?? ''))

  return normalizedName ? existingNormalizedNames.has(normalizedName) : false
}
